import FileSaver from "file-saver";
import { Autorenew, Download } from "@mui/icons-material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { format, isValid } from "date-fns";
import { useMutation, useQuery } from "react-query";
import { Table } from "../../components/Table";
import { listExports } from "../../services/exports";
import { useStyles } from "./styles";
import { useCallback } from "react";
import { queryClient } from "../../services/queryClient";

export function Exports() {
  const styles = useStyles();

  const exports = useQuery("exports", listExports);

  const downloadFile = useMutation(async (url: string) => {
    FileSaver.saveAs(url, "Audiência.csv");
  });

  const handleDownload = useCallback(
    async (url: string) => {
      await downloadFile.mutateAsync(url);
    },
    [downloadFile]
  );

  const invalidateExports = useCallback(() => {
    queryClient.invalidateQueries("exports");
  }, []);

  return (
    <>
      <div className={styles.root}>
        <Typography variant="h4">Exportações</Typography>
      </div>
      <div className={styles.rootActions}>
        <Tooltip title="Atualizar lista" placement="top">
          <IconButton onClick={invalidateExports} className={styles.btnPutList}>
            <Autorenew />
          </IconButton>
        </Tooltip>
      </div>

      <Paper variant="outlined" elevation={0} className={styles.paper}>
        <Table
          toolbar={false}
          data={exports.data as []}
          isLoading={exports.isFetching}
          columns={[
            {
              title: "Audiência",
              field: "INSIGHT_ID",
            },
            { title: "Tipo", field: "TYPE" },

            {
              title: "Status",
              align: "center",
              field: "PROCESSED",
              render: (row) =>
                Boolean(Number(row.PROCESSED)) ? (
                  <Tooltip title="Importação concluída" placement="top">
                    <CheckCircle style={{ fontSize: 25, color: green[600] }} />
                  </Tooltip>
                ) : (
                  <Tooltip title="Importação em andamento" placement="top">
                    <CircularProgress size={22} thickness={4} />
                  </Tooltip>
                ),
            },
            {
              title: "Processado em",
              field: "PROCESSED_AT",
              render: (row) =>
                row.PROCESSED_AT && isValid(new Date(row.PROCESSED_AT))
                  ? format(
                      new Date(row.PROCESSED_AT?.replace("Z", "")),
                      "dd/MM/yyyy HH:mm"
                    )
                  : "",
            },
            {
              title: "Link",
              field: "LINK",
              render: (row) => (
                <Button
                  disabled={downloadFile.isLoading || !Boolean(row.LINK)}
                  onClick={() => {
                    handleDownload(row.LINK);
                  }}
                  variant="text"
                  startIcon={<Download />}
                >
                  Download
                </Button>
              ),
            },
          ]}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
          options={{
            actionsColumnIndex: -1,
            pageSize: 5,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
      </Paper>
    </>
  );
}
